export default __webpack_public_path__ + "static/media/table.0fed1d0d.png";